export const mapDrawStyles = [
    {
        // ACTIVE (being drawn)
        // line stroke
        id: "gl-draw-line",
        type: "line",
        filter: ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": "#DBDEE6",
            "line-dasharray": [0.2, 2],
            "line-width": 2,
        },
    },
    // polygon fill
    //     {
    //         "id":
    //         "gl-draw-polygon-fill",
    //         "type":
    //         "fill",
    //         "filter":
    //             ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
    //         "paint":
    //             {
    //                 "fill-color":
    //                 "#D20C0C",
    //                 "fill-outline-color":
    //                 "#D20C0C",
    //                 "fill-opacity":
    //                 0.1
    //             }
    //     }
    // polygon mid points
    {
        id: "gl-draw-polygon-midpoint",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
        paint: {
            "circle-radius": 4,
            "circle-color": "#5161C1",
        },
    },
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": "#B7C2EB",
            "line-dasharray": [0.2, 2],
            "line-width": 2,
        },
    },
    // vertex point halos
    {
        id: "gl-draw-polygon-and-line-vertex-halo-active",
        type: "circle",
        filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
        paint: {
            "circle-radius": 7,
            "circle-color": "#FFFFFF",
        },
    },
    // vertex points
    {
        id: "gl-draw-polygon-and-line-vertex-active",
        type: "circle",
        filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#5161C1",
        },
    },

    // INACTIVE (static, already drawn)
    // line stroke
    {
        id: "gl-draw-line-static",
        type: "line",
        filter: ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": "#000000",
            "line-width": 3,
        },
    },
    // polygon fill
    {
        id: "gl-draw-polygon-fill-static",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        paint: {
            "fill-color": "#B7C2EB",
            "fill-outline-color": "#5161C1",
            "fill-opacity": 0.1,
        },
    },
    // polygon outline
    {
        id: "gl-draw-polygon-stroke-static",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": "#5161C1",
            "line-width": 3,
        },
    },
] as object[];
